import {
  getFaqs,
  getFaqsByGroup
} from "./chunk-23V3YWBC.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-RGHW4PYM.mjs";

// src/hooks/wbk/faq/listFaqs.ts
import {
  useInfiniteQuery,
  useQuery
} from "@tanstack/react-query";
var useGetFaqsList = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getFaqs", props],
    queryFn: () => getFaqs(props)
  }, options));
};
var useGetFaqByGroup = (props, options) => {
  return useInfiniteQuery(__spreadProps(__spreadValues({
    queryKey: ["getFaqsByGroup", props],
    queryFn: ({ pageParam = 1 }) => getFaqsByGroup(__spreadProps(__spreadValues({}, props), { page: pageParam })),
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const { current_page, per_page, total } = lastPage.meta;
      const total_pages = Math.ceil(total / per_page);
      return current_page < total_pages ? lastPageParam + 1 : void 0;
    }
  }, options), {
    select: (data) => {
      var _a;
      const faqs = data.pages.flatMap((page) => page.data);
      const meta = (_a = data.pages.at(-1)) == null ? void 0 : _a.meta;
      return { faqs, meta };
    },
    initialPageParam: 1,
    staleTime: Infinity
  }));
};

export {
  useGetFaqsList,
  useGetFaqByGroup
};
//# sourceMappingURL=chunk-2M5JVQDL.mjs.map